export default "__VITE_ASSET__1e4db894__"